export default __webpack_public_path__ + "static/media/title_vi_sp.e1b1e26f.png";